module.exports = __webpack_public_path__ + "static/media/reset.9e48007f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/reset.svg
// module id = 53
// module chunks = 0